document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[widget-type="CTAButton"]').forEach((element) => {
        element.addEventListener("click", () => {
            console.log("CTA Button Click")
        })
    })
})